import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import AuthGate from "./AuthGate";
import { AuthProvider } from "./context/AuthContext";
import { QuotaProvider } from "./context/QuotaContext";
import "./index.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <QuotaProvider>
          <AuthGate />
        </QuotaProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
